<rl-float-form [closeable]="false" *ngIf="sub">
    <form class="form-flex edit-data border-rows" #gradingForm="ngForm">
		<fieldset>
		    <div class="form-flex-row dual-row">
				<div class="form-flex-label">
					<label for="final-grade" class="control-label">{{'grading.form.score' | translate}}<span class="must-astrix">*</span>:</label>
				</div>
				<div class="form-flex-label grade-input">
					<input class="form-control" type="numberText" name="grade" id="final-grade" [(ngModel)]="copySub.grade" [isValid]="validateInput"/> <!--[max]="asgmt.lmsAssignmentMaxScore" [min]="0"/>-->
				</div>
				<div class="form-flex-label">
					<label> / {{asgmt.lmsAssignmentMaxScore}}</label>
				</div>
			</div>
			<div class="form-flex-row display-block">
		    	<div class="form-flex-label">
					<label for="feedback-grade" class="control-label vertical-align-middle">{{'grading.form.comments' | translate}}:</label>
		    	</div>
		    	<div class="form-flex-input">
					<textarea class="form-control" id="feedback-grade" name="feedback" [(ngModel)]="copySub.feedback" cols="30" rows="2"></textarea>
		    	</div>
		    </div>
		    <div class="justify-content">
		    	<div class="flex-end">
		    		<div class="justify-content">
		    			<div class="flex-basis margin-right">
		    				<button type="button" class="btn btn-stroke btn-thin-txt" [disabled]="!hasChanges()" (click)="save()" id="save-submission-feedback" [rlAria]="'btn.save' | translate" [rlTabIndex]>
							    {{'btn.save' | translate}}
							</button>
		    			</div>
						<div class="flex-basis">
							<button type="button" class="btn btn-primary btn-thin-txt" *ngIf="showNext" [disabled]="!hasChanges()" (click)="save('next')" id="save-submission-feedback-and-next" [rlAria]="'btn.save.next' | translate" [rlTabIndex]>
								{{'btn.save.next' | translate}}
							</button>
						</div>
		    		</div>
		    	</div>
		    </div>
		</fieldset>
	</form>
</rl-float-form>
<div class="embedded-content">
	<div class="pdf-viewer-holder">
		<rl-embedded-view *ngIf="asgmt" [file]="asgmt.file" [annotatorConfig]="annotator" [toolbarConfig]="{fullScreen : false}" class="pdfViewerDiv"></rl-embedded-view>
	</div>
</div>